import { groupsListWidgetSettingsParams as widgetSettingsParams } from 'settings/groups-list-widget';

export default {
  ...(widgetSettingsParams as any),
};
